// src/components/ui/badge.jsx
import React from "react";
import { cn } from "@/lib/utils";

export function Badge({ children, className }) {
  return (
    <span
      className={cn(
        "inline-block px-[14px] py-[9px] text-sm rounded-full bg-[#fffefc] text-[#0f3e17]",
        className
      )}
    >
      {children}
    </span>
  );
}

export default Badge;
